<template>
  <TableBox :current-page="currentPage" :meta="meta" @onChangePage="$emit('onChangePage', $event)">
    <b-table
      sticky-header
      id="my-table"
      :fields="fields"
      :items="list"
      :busy="isLoading"
      class="custom-table"
      thead-class="custom-table-header"
      tbody-tr-class="custom-table-body"
      :emptyText="$t('text.emptyText')"
      show-empty
    >
      <template #cell(index)="data">
        {{ data.index + 1 }}
      </template>

      <template #cell(items)="data">
        <p class="text-nowrap">
          {{ $t('inventory.addedVariants', { total: data.item.items.length }) }}
        </p>
        <p class="text-nowrap">
          {{ $t('inventory.addedTotalInventory', { total: totalInventory(data.item.items) }) }}
        </p>
      </template>

      <template #cell(createdAt)="data">
        <span class="text-nowrap">
          {{ data.item.createdAt | moment('YYYY-MM-DD') }}
        </span>
      </template>

      <template #cell(action)="data">
        <div class="table-action-buttons">
          <InlineButton
            variant="outline-secondary"
            size="sm"
            pill
            @click="$emit('edit', data.item.id)"
            class="has-shadow"
          >
            {{ $t('text.editButton') }}
          </InlineButton>
        </div>
      </template>
    </b-table>
  </TableBox>
</template>

<script>
import TableBox from '@/components/ui/TableBox';
import InlineButton from '@/components/ui/button/InlineButton';

export default {
  props: {
    list: Array,
    meta: Object,
    currentPage: Number,
    isLoading: Boolean,
  },

  data() {
    return {
      fields: [
        {
          key: 'index',
          label: '#',
        },
        {
          key: 'items',
          label: this.$t('table.th.products'),
        },
        {
          key: 'createdAt',
          label: this.$t('table.th.created'),
        },
        {
          key: 'action',
          label: this.$t('table.th.settings'),
        },
      ],
    };
  },

  methods: {
    totalInventory(list) {
      return list.reduce((total, item) => total + item.quantity, 0);
    },
  },

  components: {
    TableBox,
    InlineButton,
  },
};
</script>
